import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Subscription } from 'rxjs';
import { ActivityMonitoringService } from 'src/app/services/activity-monitoring.services';
@Component({
  selector: 'lib-idle-message',
  templateUrl: './idle-message.component.html',
  styleUrls: ['./idle-message.component.scss']
})
export class IdleMessageComponent implements OnInit {

  status: any;
  getAMStatusSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<IdleMessageComponent>,
    private amService: ActivityMonitoringService
  ) { }

  ngOnInit() {
    this.getAMStatusSubscription = this.amService.getAMData$.subscribe(status => {
      this.status = status;
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  // onContinue() {
  //   console.log('Continue Called');
  // }
  ngOnDestroy() {
    this.getAMStatusSubscription.unsubscribe();
  }


}
